export default class Youtube {
  constructor(object) {
    this.$object = $(object);

    this.resize();

    $(window).resize(this.resize.bind(this));
  }

  resize() {
    let w = this.$object.attr('width');
    let h = this.$object.attr('height');

    this.$object.height(this.$object.width() * h / w);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Youtube.js